import { BreadcrumbConfig } from '../../../template-config.interface';

export const MACRO_BREADCRUMB_CONFIG: BreadcrumbConfig = {
  fields: ['stage', 'adChannel', 'variant', 'cta_enabled', 'subheadline_enabled', 'legal'],

  labels: {
    stage: 'Etapa',
    adChannel: 'Medio',
    variant: 'Motivo',
    cta_enabled: 'CTA',
    subheadline_enabled: 'Bajada',
    legal: 'Legal'
  },

  formatters: {
    stage: (value: string) => {
      const stageNames: Record<string, string> = {
        CONVERSION: 'Conversión',
        CONSIDERACION: 'Consideración',
        AWARENESS: 'Awareness'
      };
      return stageNames[value] || value;
    },

    adChannel: (value: string) => {
      const channelNames: Record<string, string> = {
        google: 'Google Ads',
        meta: 'Meta Ads'
      };
      return channelNames[value] || value;
    },

    variant: (value: string) => `Motivo ${value}`,

    cta_enabled: (value: string) => (value === 'si' ? 'CTA' : null),
    subheadline_enabled: (value: string) => (value === 'si' ? 'Bajada' : null),
    legal: (value: string) => (value === 'si' ? 'Legal' : null)
  }
};
